import React from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: ({ gap }: { gap: string }) => gap,
  },
  point: {
    flexShrink: 0,
    borderRadius: '50%',
  },
});

type CustomLegendIcon = {
  customLegendIcon: React.ReactElement;
  pointColor?: never;
  pointSize?: never;
  pointOpacity?: string;
};

type CircleIcon = {
  customLegendIcon?: never;
  pointColor?: string;
  // bullet point diameter - default 10px
  pointSize?: string;
  pointOpacity?: string;
};

type Props = {
  // space between bullets and labels - default 8px
  gap?: string;
  hidePointColor?: boolean;
} & (CustomLegendIcon | CircleIcon);

export const LegendItem = (props: React.PropsWithChildren<Props>) => {
  const {
    pointSize = '10px',
    hidePointColor,
    pointColor,
    gap = '8px',
    children,
    pointOpacity = '100%',
    customLegendIcon,
  } = props;
  const classes = useStyles({ gap });

  return (
    <div className={classes.wrapper}>
      {customLegendIcon ||
        (!hidePointColor && (
          <div
            className={classes.point}
            style={{ width: pointSize, height: pointSize, backgroundColor: pointColor, opacity: pointOpacity }}
          />
        ))}
      {children}
    </div>
  );
};
